// extracted by mini-css-extract-plugin
module.exports = {"vars":"appbar_vars__3iePF","sticky":"appbar_sticky__0_u_9","stickyVisible":"appbar_stickyVisible__4ifGg","root":"appbar_root__eNDwk"};